import { InvoiceFilters } from "../types/invoices"

export const invoiceListQueryKeys = {
  all: ["invoices", "list"] as const,
  filters: (filters: InvoiceFilters) =>
    [...invoiceListQueryKeys.all, "filters", filters] as const,
}
